import { render, staticRenderFns } from "./ResourceListCard.vue?vue&type=template&id=27738dfd&scoped=true&"
import script from "./ResourceListCard.vue?vue&type=script&lang=js&"
export * from "./ResourceListCard.vue?vue&type=script&lang=js&"
import style0 from "./ResourceListCard.vue?vue&type=style&index=0&id=27738dfd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27738dfd",
  null
  
)

export default component.exports